<script type="text/ecmascript-6">
    import TileQuestion from "./mixin/TileQuestion.vue";

    export default {
        mixins: [
            TileQuestion
        ],
        props: {
            title: {
                default(){
                    return 'Cat Flap';
                }
            },
            component_id: {
                default(){
                    return 'hardware_cat_flap';
                }
            },
            slab: {
                required: true
            },
            securedByDesign: {
                required: true
            },
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.slab, this.securedByDesign);
            },
            thumbURL(){
                return '/thumb/hardware/';
            },
            url(){
                return '/api/options/' + this.fabricator + '/hardware-cat-flap?slab=' + this.slab
                        + '&secured_by_design=' + this.securedByDesign;
            },
            cache_key(){
                return '_' + this.slab + '_' + this.securedByDesign;
            }
        },
        watch: {
            'slab': function (val, oldVal) {
                this.update_options();
            },
            'securedByDesign': function (val, oldVal) {
                this.update_options();
            },
        }
    }
</script>
